import { injectable } from 'inversify';
import container from '@/container';
import {
    CONTRACTS,
    AuditServiceContract,
    FetchServiceContract
} from '@/core/contracts';
import { UserActionType } from '@/dto';

@injectable()
export class AuditService implements AuditServiceContract {
    public async logAction(
        contextId: any,
        action: UserActionType,
        data: any
    ): Promise<void> {
        const fetchService = await container.get<FetchServiceContract>(
            CONTRACTS.FetchService
        );
        await fetchService.post(`/contexts/${contextId}/audit/actions`, {
            action,
            data: JSON.stringify(data)
        });
    }
}
